import { Tooltip } from '../../JournalPage/JournalStyles';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { IconButton } from '@material-ui/core';


export function reportsSettingEmailColumn({ t, deleteEmailModal }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 60,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('reportsPage_emailColumn'),
      accessor: 'email',
      style: { textAlign: 'center' },
      filterable: false
    },
    {
      Header: t('reportsPage_actionsColumn'),
      accessor: 'id',
      Cell: ({ original }) => (
        <div className="center" style={{ margin: '-5px 0' }}>
          <Tooltip placement="top" title={t('reportsPage_deleteEmailBtn')}>
            <IconButton
              size="small"
              children={<DeleteIcon fontSize="small" />}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                deleteEmailModal.open(original);
              }}
            />
          </Tooltip>
        </div>
      ),
      width: 80,
      filterable: false
    },
  ];
}
